import React, { useContext, useEffect, useState } from 'react'
import { Card, CardBody, IconButton, Checkbox, Spinner, Button } from "@material-tailwind/react";
import { Pagination, SearchAndAddBtn, Switch, THead } from '../../Components';
import { get_FeedbackCategory, get_Feedback_Sub_Category, update_FeedbackCategory_Priority, update_Feedback_Sub_Priority, } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import { RiDeleteBinLine } from 'react-icons/ri';
import { RxHamburgerMenu } from 'react-icons/rx';
import FeedbackCategoryModel from '../../Components/Modals/FeedbackCategoryModel';
import { AiOutlinePlusSquare } from 'react-icons/ai';
import { MdOutlineCategory } from 'react-icons/md';
import { BiEdit } from 'react-icons/bi';
import FeedbackSubCategoryModel from '../../Components/Modals/FeedbackSubCategoryModel';
import moment from 'moment'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

export const CategoryList = ({ title }) => {
    const { permissions, tokenType, deleteUpdateYes, setopenSubCategory, setDeleteUpdateTag, setDeleteUpdateItem, setAddEditDeleteTag, setFormData, confirmationModalShow, setConfirmationModalShow, handleSwitchUpdate, isLoading, deleteUpdateTag, checkedValues, handleCheckboxChange, currentPage, totalPage, perPage, search, setDeleteUpdateYes, setIsLoading, setCurrentPage, setPerPage, setTotalPage, currentPageData, setCurrentPageData, filterDropdown, handleOpen, isAscending, sortData } = useContext(NewContext);
    const simpleFields = [
        { name: "Category" },
        // { name: "Created At", sortable: true, field: 'createdAt' },
        { name: "Updated At", sortable: true, field: 'updatedAt' },
    ];
    const [pagePermissions, setPagePermissions] = useState({
        CU: true,
        R: true,
        D: true
    });
    const simpleSubFields = [
        { name: "Sub Category" },
        { name: "Updated At", sortable: true, field: 'updatedAt' },
    ]
    const dropdownFields = [{ name: "Active", sortable: false }];
    const dropdownSubFields = [{ name: "Active", sortable: false }];
    const totalFields = simpleFields.length + dropdownFields.length + 2;
    const totalSubFields = simpleSubFields.length + dropdownSubFields.length + 2;
    const [categoryId, setCategoryId] = useState('');
    const [categoryName, setCategoryName] = useState('');
    const [subCategoryData, setSubCategoryData] = useState([]);
    const [isSubCategoryLoading, setIsSubCategoryLoading] = useState(false);
    const [isCategoryPriority, setIsCategoryPriority] = useState(false);
    const [isSubCategoryPriority, setIsSubCategoryPriority] = useState(false);



    const getFeedbackCategoryData = async (_currentPage = 1, sortName = sortData, sortType = isAscending) => {
        setIsLoading(true);
        try {
            const getFeedbackCategory = await get_FeedbackCategory(_currentPage, perPage, search, filterDropdown, sortName, sortType);
            if (getFeedbackCategory) {
                const { status, data, currentPage, perPage, totalPage } = getFeedbackCategory;
                if (status) {
                    setCurrentPageData(data);
                    setCurrentPage(currentPage);
                    setPerPage(perPage);
                    setTotalPage(totalPage || 1);
                } else {
                    setCurrentPageData([]);
                }
            }
        } catch (error) {
            console.error(error);
        }
        setIsLoading(false);
    }

    const getFeedbackSubCategoryData = async (categoryId) => {
        setIsSubCategoryLoading(true);
        try {
            const getFeedbackCategory = await get_Feedback_Sub_Category({ categoryId });
            if (getFeedbackCategory) {
                const { status, data } = getFeedbackCategory;
                if (status) {
                    setSubCategoryData(data);
                } else {
                    setSubCategoryData([]);
                }
            }
        } catch (error) {
            console.error(error);
        }
        setIsSubCategoryLoading(false);
    }


    const handleDragEnd = async (e) => {
        if (!pagePermissions?.CU) return;
        if (!e.destination) return;
        let tempData = Array.from(currentPageData);
        let [source_data] = tempData.splice(e.source.index, 1);
        source_data.priority = e.destination.index + 1;
        tempData.splice(e.destination.index, 0, source_data);
        let newData = tempData.map((_ele, i) => ({ ..._ele, priority: i + 1 }));
        const { data, status } = await update_FeedbackCategory_Priority({ updates: newData })
        if (status) {
            setCurrentPageData(data);
        }
        setIsCategoryPriority(!isCategoryPriority)
    };


    const handleSubDragEnd = async (e) => {
        if (!pagePermissions?.CU) return;
        if (!e.destination) return;
        let tempData = Array.from(subCategoryData);
        let [source_data] = tempData.splice(e.source.index, 1);
        source_data.priority = e.destination.index + 1;
        tempData.splice(e.destination.index, 0, source_data);
        let newData = tempData.map((_ele, i) => ({ ..._ele, priority: i + 1 }));
        const { data, status } = await update_Feedback_Sub_Priority({ updates: newData })
        if (status) {
            setSubCategoryData(data);
        }
        setIsSubCategoryPriority(!isSubCategoryPriority)
    };



    useEffect(() => {
        getFeedbackCategoryData(currentPage, sortData, isAscending);
        setDeleteUpdateTag("");
    }, [deleteUpdateTag, deleteUpdateYes, search, currentPage, perPage, filterDropdown, isCategoryPriority, pagePermissions, sortData, isAscending]);


    useEffect(() => {
        getFeedbackSubCategoryData(categoryId);
    }, [categoryId, isSubCategoryPriority, pagePermissions]);

    useEffect(() => {
        if (tokenType === 'ldap') {
            const update = permissions?.subPermissions?.find((route) => route.name === 'Category_List_message');
            setPagePermissions({ ...pagePermissions, CU: update?.CU, R: update?.R, D: update?.D })
        }
    }, [tokenType, permissions])

    useEffect(() => {
    }, [pagePermissions])


    useEffect(() => {
        document.title = title;
    }, [title])
    return (
        <>
            <SearchAndAddBtn title={`Category`} addJsonBtn={true} addBtn={pagePermissions?.CU ? true : false} deleteUpdateTag='all-delete-feedback-category' perPageCount={false} resetFilterBtn={false} />

            <div className='grid grid-cols-12 gap-2'>
                <Card className="overflow-hidden col-span-6 w-full h-fit rounded-md shadow-none">
                    <CardBody className="overflow-x-auto w-100 py-2.5 px-[5px] card-body-scrollbar">


                        <DragDropContext onDragEnd={handleDragEnd}>
                            <table className="!w-full min-w-max table-auto text-left">
                                <THead simpleFields={simpleFields} dropdownFields={dropdownFields} />
                                <Droppable droppableId='droppable-1'>
                                    {
                                        (provider) => (
                                            <tbody className='table-scroll' ref={provider.innerRef} {...provider.droppableProps}>

                                                {
                                                    isLoading ?
                                                        <tr>
                                                            <td colSpan={totalFields} className='py-12'>
                                                                <div className="flex justify-center items-center">
                                                                    <Spinner />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        : currentPageData?.length === 0 ?
                                                            <tr>
                                                                <td colSpan={totalFields} className='py-12 bg-gray-200'>
                                                                    <div className="flex justify-center items-center">
                                                                        No Data Found
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            : currentPageData?.map((_ele, i) => {
                                                                const isLast = i === currentPageData?.length - 1;
                                                                const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;

                                                                return (

                                                                    <Draggable draggableId={_ele._id} key={_ele._id} index={i}>
                                                                        {
                                                                            (provider) => (

                                                                                <tr key={i} className='border-b border-blue-gray-50' ref={provider.innerRef} {...provider.draggableProps} {...provider.dragHandleProps}>
                                                                                    <td className={classes}>
                                                                                        <Checkbox
                                                                                            className='w-[18px] h-[18px] border-[1.5px] rounded-[3.6px] border-[#1E3354] checked:bg-[#0047FF] checked:border-transparent'
                                                                                            id={`slider-${_ele._id}`}
                                                                                            value={`${_ele._id}`}
                                                                                            disabled={!pagePermissions?.CU}
                                                                                            checked={checkedValues.includes(`${_ele._id}`)}
                                                                                            onChange={() => handleCheckboxChange(`${_ele._id}`)}
                                                                                        />
                                                                                    </td>

                                                                                    <td className={classes}>
                                                                                        <div className="flex items-center">
                                                                                            <span className={`font-normal text-[#0047FF] cursor-pointer text-[17px] ${!_ele.name && `text-gray-500`}`} onClick={() => { setCategoryId(_ele._id); setCategoryName(_ele.name); }}>{_ele.name || `None`}</span>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className={classes}>
                                                                                        <div className="flex items-center">
                                                                                            <span className={`font-normal text-[17px] ${!_ele.updatedAt && `text-gray-500`}`}>{moment(_ele?.updatedAt).format('DD/MM/YYYY, hh:mm A')}</span>
                                                                                        </div>
                                                                                    </td>

                                                                                    {
                                                                                        ["isActive"].map((_is_ele, i) => (
                                                                                            <td className={classes} key={i}>
                                                                                                <div className="ml-1">
                                                                                                    <Switch disabled={!pagePermissions?.CU} id={_ele._id} name={_is_ele} onChange={(e) => { setDeleteUpdateYes("update-feedback-category"); handleSwitchUpdate(e); }} checked={_ele[_is_ele]} />
                                                                                                </div>
                                                                                            </td>
                                                                                        ))
                                                                                    }

                                                                                    <td className={classes}>
                                                                                        <div className="flex items-center gap-2">
                                                                                            <IconButton className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.CU} onClick={() => { setDeleteUpdateYes("update-feedback-category"); setAddEditDeleteTag(`update`); setFormData(_ele); handleOpen() }}>
                                                                                                <BiEdit />
                                                                                            </IconButton>
                                                                                            <IconButton className='bg-[#EAEDF3] text-[#F62929] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.D} onClick={() => { setDeleteUpdateYes("delete-feedback-category"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                                                                                                <RiDeleteBinLine />
                                                                                            </IconButton>
                                                                                            {categoryName !== _ele.name && <IconButton className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' onClick={() => { setCategoryId(_ele._id); setCategoryName(_ele.name); }}>
                                                                                                <MdOutlineCategory />
                                                                                            </IconButton>}
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className={classes} {...provider.dragHandleProps}>
                                                                                        <RxHamburgerMenu size={24} />
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    </Draggable>
                                                                );
                                                            })
                                                }
                                                {provider.placeholder}
                                            </tbody>
                                        )
                                    }
                                </Droppable>
                            </table>
                        </DragDropContext>


                    </CardBody>
                </Card>
                <Card className="overflow-hidden col-span-6 w-full bg-gray-300 rounded-md shadow-none h-[750px]">
                    <CardBody className="overflow-x-auto w-100 py-2.5 px-[5px] card-body-scrollbar">
                        {categoryName !== "" ? (<>
                            <div className='flex justify-between items-center'>
                                <h3 className={`ml-2 font-medium text-[18px] text-[#1E1627] leading-none m-5`}>{categoryName}</h3>
                                <Button
                                    className='lg:ml-2.5 lg:px-4 2xl:px-5 flex items-center bg-[#0047FF] capitalize text-sm leading-none font-medium whitespace-nowrap shadow-none hover:shadow-none mb-2'
                                    onClick={() => {
                                        setDeleteUpdateYes(`add`);
                                        setAddEditDeleteTag(`add`);
                                        setFormData({});
                                        setopenSubCategory(true);
                                    }}
                                >
                                    Add New Sub Category <AiOutlinePlusSquare size={"22px"} className='ml-2.5' />
                                </Button>
                            </div>
                            <DragDropContext onDragEnd={handleSubDragEnd}>
                                <table className="w-full min-w-max table-auto text-left rounded-md bg-white ">
                                    <THead simpleFields={simpleSubFields} dropdownFields={dropdownSubFields} isSelectAll={false} isSub={true} />
                                    <Droppable droppableId='droppable-1'>
                                        {
                                            (provider) => (

                                                <tbody ref={provider.innerRef} {...provider.droppableProps}>
                                                    {
                                                        isSubCategoryLoading ?
                                                            <tr>
                                                                <td colSpan={totalSubFields} className='py-12'>
                                                                    <div className="flex justify-center items-center">
                                                                        <Spinner />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            : subCategoryData?.length === 0 ?
                                                                <tr>
                                                                    <td colSpan={totalSubFields} className='py-12 bg-gray-200'>
                                                                        <div className="flex justify-center items-center">
                                                                            No Data Found
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                : subCategoryData?.map((_ele, i) => {
                                                                    const isLast = i === subCategoryData?.length - 1;
                                                                    const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;

                                                                    return (
                                                                        <Draggable draggableId={_ele._id} key={_ele._id} index={i}>
                                                                            {
                                                                                (provider) => (
                                                                                    <tr key={i} className='border-b border-blue-gray-50' ref={provider.innerRef} {...provider.draggableProps} {...provider.dragHandleProps}>
                                                                                        <td className={classes}>
                                                                                            <div className="flex items-center">
                                                                                                <span className={`font-normal text-[17px] ${!_ele.name && `text-gray-500`}`}>{_ele.name || `None`}</span>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td className={classes}>
                                                                                            <div className="flex items-center">
                                                                                                <span className={`font-normal text-[17px] ${!_ele.updatedAt && `text-gray-500`}`}>{moment(_ele?.updatedAt).format('DD/MM/YYYY, hh:mm A')}</span>
                                                                                            </div>
                                                                                        </td>

                                                                                        {
                                                                                            ["isActive"].map((_is_ele, i) => (
                                                                                                <td className={classes} key={i}>
                                                                                                    <div className="ml-1">
                                                                                                        <Switch disabled={!pagePermissions?.CU} id={_ele._id} name={_is_ele} onChange={(e) => { setDeleteUpdateYes("update-feedback-sub-category"); handleSwitchUpdate(e); }} checked={_ele[_is_ele]} />
                                                                                                    </div>
                                                                                                </td>
                                                                                            ))
                                                                                        }

                                                                                        <td className={classes}>
                                                                                            <div className="flex items-center gap-2">
                                                                                                <IconButton className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.CU} onClick={() => { setDeleteUpdateYes("update-feedback-sub-category"); setAddEditDeleteTag(`update`); setFormData(_ele); setopenSubCategory(true); }}>
                                                                                                    <BiEdit />
                                                                                                </IconButton>
                                                                                                <IconButton className='bg-[#EAEDF3] text-[#F62929] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.D} onClick={() => { setDeleteUpdateYes("delete-feedback-sub-category"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                                                                                                    <RiDeleteBinLine />
                                                                                                </IconButton>

                                                                                            </div>
                                                                                        </td>
                                                                                        <td className={classes} {...provider.dragHandleProps}>
                                                                                            <RxHamburgerMenu size={24} />
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            }
                                                                        </Draggable>
                                                                    );
                                                                })
                                                    }
                                                    {provider.placeholder}
                                                </tbody>
                                            )
                                        }
                                    </Droppable>
                                </table>
                            </DragDropContext>
                        </>) : (<>
                            <div className='flex items-center'>
                                Select any Category to view
                            </div>
                        </>)}

                    </CardBody>
                </Card>
            </div >
            {
                totalPage > 1 &&
                <Pagination currentPage={currentPage} totalPage={totalPage} getData={getFeedbackCategoryData} />
            }
            <FeedbackCategoryModel />
            <FeedbackSubCategoryModel />
        </>
    )
}
CategoryList.defaultProps = {
    title: "Message | Category"
};



export default CategoryList
